import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full mb-5" }
const _hoisted_2 = { class: "w-full mb-5" }
const _hoisted_3 = { class: "w-full mb-5" }
const _hoisted_4 = { class: "w-full mb-5 flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200" }
const _hoisted_5 = { class: "text-xs text-gray-500" }
const _hoisted_6 = { class: "w-full mb-5 flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200" }
const _hoisted_7 = { class: "text-xs text-gray-500" }
const _hoisted_8 = { class: "w-full mb-5 flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200" }
const _hoisted_9 = { class: "text-xs text-gray-500" }
const _hoisted_10 = {
  key: 0,
  class: "w-full mb-5"
}
const _hoisted_11 = { class: "relative mt-1" }
const _hoisted_12 = ["type"]
const _hoisted_13 = { class: "flex" }

import { ref } from 'vue'
import Agent from '@/composables/admin/agent'
import { isValidEmail, resetErrors, handleApiError, isLoggedIn } from '@/utils/common'
import { Agent as AgentType } from '@/types/admin'


export default /*@__PURE__*/_defineComponent({
  __name: 'SaveSubAgent',
  props: ['data'],
  emits: ['success', 'error'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const isLoading = ref<boolean>(false)
const isPasswordVisible = ref<boolean>(false)
const { createSubAgent, updateSubAgent } = Agent()
const authUser = isLoggedIn()

const subAgent = ref<AgentType>({
   id: '',
   name: '',
   email: '',
   commission: 0,
   address: '',
   phone: '',
   isParent: false,
   website_login: false,
   is_admin: false,
   active: true,
   password: ''
})

const errors = ref<any>({
   name: false,
   email: false,
   phone: false,
   password: false
})

if (props.data) {
   subAgent.value = {
      id: props.data.id || '',
      name: props.data.name || '',
      email: props.data.email || '',
      commission: props.data.commission || 0,
      address: props.data.address || '',
      phone: props.data.phone || '',
      isParent: props.data.isParent || false,
      website_login: props.data.website_login === true || props.data.website_login === 1,
      is_admin: props.data.is_admin === true || props.data.is_admin === 1,
      active: props.data.status === 1 || props.data.status === true,
      password: ''
   }
}

const toggleWebsiteLogin = () => {
   subAgent.value.website_login = !subAgent.value.website_login
}

const validateForm = () : boolean => {

   let response = true

   if (subAgent.value.name == '') {
      response = false
      errors.value.name = true
   }

   if (subAgent.value.website_login || subAgent.value.email != '') {
      if (subAgent.value.email == '' || !isValidEmail(subAgent.value.email)) {
         response = false
         errors.value.email = true
      }
   }

   if (subAgent.value.phone == '') {
      response = false
      errors.value.phone = true
   }

   if (subAgent.value.website_login) {
      if (!props.data) {
         if (!subAgent.value.password || subAgent.value.password.length < 6) {
            response = false
            errors.value.password = true
         }
      } else {
         if (subAgent.value.password && subAgent.value.password.length < 6) {
            response = false
            errors.value.password = true
         }
      }
   }

   return response 
}

const handleSubmit = async () => {

   resetErrors(errors.value)
   const isValid = validateForm()

   if (isValid && !isLoading.value) {
      
      isLoading.value = true

      if (!props.data) {

         const response = await createSubAgent(subAgent.value)
         if (response.status == 201) {
            emit('success')
         } else {
            const error = handleApiError(response)
            emit('error', error)
         }
      } else {

         const response = await updateSubAgent(subAgent.value)
         if (response.status == 200) {
            emit('success')
         } else {
            const error = handleApiError(response)
            emit('error', error)
         }
      }

      isLoading.value = false
   }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        for: "name",
        class: _normalizeClass([!errors.value.name ? 'text-gray-700' : 'text-theme-error', "block text-sm font-medium"])
      }, "Name", 2),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((subAgent.value.name) = $event)),
        type: "text",
        class: _normalizeClass([!errors.value.name ? 'border-gray-300' : 'border-theme-error', "mt-1 outline-none border rounded-sm h-10 w-full block pl-2 text-gray-500 text-sm"]),
        placeholder: "Enter name"
      }, null, 2), [
        [_vModelText, subAgent.value.name]
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        for: "email",
        class: _normalizeClass([!errors.value.email ? 'text-gray-700' : 'text-theme-error', "block text-sm font-medium"])
      }, " Email" + _toDisplayString(subAgent.value.website_login ? ' *' : ' (Optional)'), 3),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((subAgent.value.email) = $event)),
        type: "text",
        class: _normalizeClass([!errors.value.email ? 'border-gray-300' : 'border-theme-error', "mt-1 outline-none border rounded-sm h-10 w-full block pl-2 text-gray-500 text-sm"]),
        placeholder: "Enter email address"
      }, null, 2), [
        [_vModelText, subAgent.value.email]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", {
        for: "phone",
        class: _normalizeClass([!errors.value.phone ? 'text-gray-700' : 'text-theme-error', "block text-sm font-medium"])
      }, "Phone Number", 2),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((subAgent.value.phone) = $event)),
        type: "text",
        class: _normalizeClass([!errors.value.phone ? 'border-gray-300' : 'border-theme-error', "mt-1 outline-none border rounded-sm h-10 w-full block pl-2 text-gray-500 text-sm"]),
        placeholder: "Enter phone number"
      }, null, 2), [
        [_vModelText, subAgent.value.phone]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "block text-sm font-semibold text-gray-800" }, "Status", -1)),
        _createElementVNode("span", _hoisted_5, _toDisplayString(subAgent.value.active ? 'Active' : 'Inactive'), 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (subAgent.value.active = !subAgent.value.active)),
        class: _normalizeClass([subAgent.value.active ? 'bg-indigo-600' : 'bg-gray-200', "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none"])
      }, [
        _createElementVNode("span", {
          class: _normalizeClass([subAgent.value.active ? 'translate-x-5' : 'translate-x-0', "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"])
        }, null, 2)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "block text-sm font-semibold text-gray-800" }, "Is Admin", -1)),
        _createElementVNode("span", _hoisted_7, _toDisplayString(subAgent.value.is_admin ? 'Admin' : 'Staff'), 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (subAgent.value.is_admin = !subAgent.value.is_admin)),
        class: _normalizeClass([subAgent.value.is_admin ? 'bg-indigo-600' : 'bg-gray-200', "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none"])
      }, [
        _createElementVNode("span", {
          class: _normalizeClass([subAgent.value.is_admin ? 'translate-x-5' : 'translate-x-0', "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"])
        }, null, 2)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "block text-sm font-semibold text-gray-800" }, "Allow Website Login", -1)),
        _createElementVNode("span", _hoisted_9, _toDisplayString(subAgent.value.website_login ? 'Allowed' : 'Disabled'), 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        onClick: toggleWebsiteLogin,
        class: _normalizeClass([subAgent.value.website_login ? 'bg-indigo-600' : 'bg-gray-200', "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none"])
      }, [
        _createElementVNode("span", {
          class: _normalizeClass([subAgent.value.website_login ? 'translate-x-5' : 'translate-x-0', "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"])
        }, null, 2)
      ], 2)
    ]),
    (subAgent.value.website_login)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("label", {
            for: "password",
            class: _normalizeClass([!errors.value.password ? 'text-gray-700' : 'text-theme-error', "block text-sm font-medium"])
          }, _toDisplayString(props.data ? 'New Password (leave empty to keep current)' : 'Website Password *'), 3),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((subAgent.value.password) = $event)),
              type: isPasswordVisible.value ? 'text' : 'password',
              class: _normalizeClass([!errors.value.password ? 'border-gray-300' : 'border-theme-error', "outline-none border rounded-sm h-10 w-full block pl-2 pr-10 text-gray-500 text-sm"]),
              placeholder: "Enter password"
            }, null, 10, _hoisted_12), [
              [_vModelDynamic, subAgent.value.password]
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (isPasswordVisible.value = !isPasswordVisible.value)),
              class: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 focus:outline-none"
            }, [
              _createElementVNode("i", {
                class: _normalizeClass([isPasswordVisible.value ? 'pi pi-eye' : 'pi pi-eye-slash', "text-sm"])
              }, null, 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("button", {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (handleSubmit())),
        type: "button",
        class: _normalizeClass([isLoading.value ? 'cursor-not-allowed opacity-70' : 'hover:bg-indigo-700', "ml-auto mt-10 bg-indigo-600 py-2 px-10 border border-transparent rounded-md shadow-sm text-sm font-medium text-white outline-none"])
      }, " Save ", 2)
    ])
  ], 64))
}
}

})